import React, { useState } from 'react';
import { Modal, Button, TextField, MenuItem, Select, FormControl, InputLabel, TextareaAutosize, Box, Typography } from '@mui/material';
import Grid from "@material-ui/core/Grid";
import { labels } from "_utils/labels";
import Link from "@material-ui/core/Link";
import { logo } from 'images';
import { CustomTextArea,CommonSelect,CustomComments ,AutocompleteInput,DropdownTableInput} from '_components';

const RejectReason = ({ open, onConfirm, handleClose,initialData }) => {
    const [reason, setReason] = useState('');
    const [newReason, setNewReason] = useState({});
    const [comments, setComments] = useState('');

    const reasons = initialData?.map(option => ({ value: option.ReasonID, label: option.ReasonName })) || [];

    const [isDisable,setIsDisable] = useState(false);

    const handleNewReasonChange = (val) => {
        let selectedObj = reasons.filter(reason => reason.value === val);
        setNewReason(selectedObj);
        setReason(val);
        if(val === 0){
            setIsDisable(false)
        }
        else{
            setIsDisable(true);
        }
    };

    const handleCommentsChange = (value) => {
        setComments(value);
    };

    const handleConfirm = () => {
        onConfirm(newReason, comments);
    };

    return (
        <Modal
            open={open}
            aria-labelledby="child-modal-title"
            aria-describedby="child-modal-description"
        >
            <Box className="modalpopup inputtags RejectioninputModal ">
                <Box className="row modalpopupinner">
                    <Grid item xs={12} className="forgotpassword p-0">
                        <Link href="#" variant="logo" className="wgllogo">
                            <img src={logo} alt="logo"></img>
                            {labels.eServicePortal}
                        </Link>
                        <Typography component="h2" variant="body1">
                            Rejection Reason
                        </Typography>
                    </Grid>
                    <Box className="p-0">
                      
                        <Grid container>
                            <Grid xs={12} sm={12} md={12}>
                                <Grid component='div' style={{ width:'100%'}}>
                                <DropdownTableInput
              value={reason}
              label={`Select Reason`}
              onChange={(e) => handleNewReasonChange(e)}
              options={reasons}
            
            />

                                </Grid>
            

                            </Grid>


                        </Grid>
           
                  
                                <CustomComments
                                label="Comments (Optional)"
                                maxLength={1000}
                                value={comments}
                                onChange={(e)=>handleCommentsChange(e.target.value)}
                            
                            />
                

                       
                      
                        <Box className="Filtercontainerinner">
                                                <Typography component="div" className="CreateMarketerbutton">
                                                    <Button
                                                        type="submit"
                                                        variant="contained"
                                                        className='submitbutton'
                                                        color="primary"
                                                        //disabled={!isFormValid}
                                                        onClick={handleConfirm}
                                                        disabled={!isDisable}
                                                    >
                                                        Confirm
                                                    </Button>
                                                    <Button variant="contained" color="red" className="cancelbutton" 
                                                    // onClick={handleCancelClick}
                                                    onClick={handleClose}
                                                    >
                                                        Cancel
                                                    </Button>
                                                </Typography>
                                                </Box>
                        {/* <Box className="Filtercontainerinner">
                        <Typography component="div" className="CreateMarketerbutton ">
                        <Button variant="contained" color="red" className="cancelbutton"  onClick={handleClose}>
                                Cancel
                            </Button>
                            <Button type="submit"
                                fullWidth
                                variant="contained"
                                color="primary"
                                className='submitbutton'

                            // disabled={!isDataChanged} >
                            >
                                Save
                            </Button>
                             
                            
                             
                       
                        </Typography>
                        </Box> */}
                    </Box>
                </Box>
            </Box>
        </Modal>
    );
};

export default RejectReason;